import {
  take,
  call,
  put,
  select,
  fork,
  takeLatest,
  delay,
} from 'redux-saga/effects';
import { getToken } from '../../../selectors/authSelectors';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import { getPolicyNumberFromStore } from '../../../selectors/policyNumberSelector';
import { FRAME_APP_MOUNTED } from '../../../actions/frameActions';
import { SHOW_MODAL } from '../../../actions/uiActions';
import {
  VHIS_MODAL_DISPLAY,
  FETCH_STEP_COUNT_SUMMARY,
  AXAGOAL_LOAD_FAIL,
  FETCH_CAMPAIGN_STARTED,
  toggleCampaignButton,
  FETCH_AXA_GOAL_CUSTOMER_STATE_SUCCESS,
  EMMA_AXA_GOAL_POPUP,
  CLOSED_AXA_GOAL_DISCLAIMER,
  SHOW_AXA_GOAL_SEE_ALL_POLICY,
  SHOW_AXA_GOAL_SUPPORT,
  FETCH_AKTIVO_STEP_STATS_SUCCESS,
  FETCH_AKTIVO_STEP_STATS,
} from '../actions/vhisAction';
import { SHOW_AXA_GOAL_DASHBOARD } from '../../../modules/emma-common/actions';
import { createMatchSelector, LOCATION_CHANGE } from 'connected-react-router';
import {
  getStepCountSummaryApi,
  getDisclaimerInfoApiApi,
  getDisclaimerInfoApiChannel,
  getDisclaimerInfoApiKey,
  getAxaGoalCustomerState,
  getAxaGoalSupportEntityCode,
  getAxagoalIsFirstYear,
  getCampaignDetail,
} from '../selectors/vhisSelectors';
import _ from 'lodash';
import uuidv4 from 'uuid/v4';
import {
  EMMA_AXA_GOAL,
  EMMA_MY_PRIVILEGES_PATH_NAME,
} from '../../../constants/constants';
import HomePagePopUpRegistry from '../../../registries/HomePagePopUpRegistry';
import { BANNER_TO_SHOW, MOB_PREFIX } from '../../../actions/appActions';
import {
  getCustomerPoliciesByPolicyNumber,
  getCustomerPolicies,
} from '../../../selectors/userSelectors';
import { AxaGoalShowType } from '../types/VhisConfig';
import { goto } from '../../../actions/historyActions';
import { fetchCustState, putCustState } from '../../../actions/userActions';
import { getHaveReadNewFeatures } from '../../../selectors/sideBarItemSelectors';
import { pushHaveReadNewFeatureSingle } from '../../../actions/sideBarItemActions';
import { isApp } from '../../../utils';
import { AktivoAPIClient } from '@axa-asia/aktivo-my-wellness-dashboard';
import { isDateObjectValid } from '../../../utils/common';
import moment from 'moment';

const AXA_GOAL_DASHBOARD_HOME_DEEPLINK_ID = 'emma-vhis/dashboard/home';
const AXA_GOAL_DASHBOARD_PRIVILEGES_DEEPLINK_ID =
  'emma-vhis/dashboard/myprivileges';
const AXA_GOAL_SEE_ALL_POLICY_DEEPLINK_HOME = 'emma-vhis/see-all-policy/home';
const AXA_GOAL_SEE_ALL_POLICY_DEEPLINK_MYPRIVILEGES =
  'emma-vhis/see-all-policy/myprivileges';
const AXA_GOAL_SUPPORT_DEEPLINK_HOME = 'emma-vhis/support/home';
const AXA_GOAL_SUPPORT_WGP_DEEPLINK_HOME = 'emma-vhis/support-WGP/home';
const AXA_GOAL_SUPPORT_SH_DEEPLINK_HOME = 'emma-vhis/support-SH/home';

const AXA_GOAL_SUPPORT_DEEPLINK_MYPRIVILEGES = 'emma-vhis/support/myprivileges';
const AXA_GOAL_SUPPORT_WGP_DEEPLINK_MYPRIVILEGES =
  'emma-vhis/support-WGP/myprivileges';
const AXA_GOAL_SUPPORT_SH_DEEPLINK_MYPRIVILEGES =
  'emma-vhis/support-SH/myprivileges';

export function* getAxagoalLastUpdateTime(policyNumber: string) {
  let lastUpdateTime;
  const disclaimerUrl = yield select(getDisclaimerInfoApiApi);
  if (policyNumber && disclaimerUrl) {
    const res = yield call(myAxaFetchWithToken, disclaimerUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    const data = yield res.json();
    const customerState =
      (data && data.length > 0 && data[0].custValue) || '{}';
    const custValue = JSON.parse(customerState);
    const axagoalPolicies =
      custValue && custValue.policies ? custValue.policies : undefined;
    const isLastUpdateTime = custValue && custValue.lastUpdateTime;
    const isAcceptedWGPDisclaimer = !!(
      custValue && custValue.isAcceptedDisclaimer
    );
    const isJoineddWGPAxaGoal = !!(custValue && custValue.isJoinedAxaGoal);
    const axagoalModle = _.find(
      axagoalPolicies,
      (axagoalItem) => axagoalItem.policyNumber === policyNumber,
    );
    const policyItem = yield select(
      getCustomerPoliciesByPolicyNumber,
      policyNumber,
    );
    if (
      axagoalModle &&
      axagoalModle.isAcceptedAxaGoalTnc &&
      axagoalModle.isAcceptedHealthKeeperTnc
    ) {
      // acceptedAxaGoalTncTime,acceptedHealthKeeperTncTime
      lastUpdateTime = axagoalModle.lastUpdateTime;
    } else if (
      policyItem.isWiseGuardProPolicyFlag === 'Y' &&
      policyItem.policyType === 'POL' &&
      isAcceptedWGPDisclaimer &&
      isJoineddWGPAxaGoal
    ) {
      lastUpdateTime = isLastUpdateTime;
    }
  }
  return lastUpdateTime;
}

export function* fetchAxaGoalDisclaimerInfo() {
  const axaGoalCustomerState = yield select(getAxaGoalCustomerState);
  if (axaGoalCustomerState) {
    return axaGoalCustomerState;
  }
  const disclaimerChannel = yield select(getDisclaimerInfoApiChannel);
  const disclaimerKey = yield select(getDisclaimerInfoApiKey);
  if (!disclaimerChannel || !disclaimerKey) {
    console.error('disclaimerChannel or disclaimerKey undefined');
    throw new Error('disclaimerChannel or disclaimerKey undefined');
  }
  const customerState = yield fetchCustState(disclaimerKey, disclaimerChannel);
  const custValue: object = JSON.parse(customerState);
  yield put({
    type: FETCH_AXA_GOAL_CUSTOMER_STATE_SUCCESS,
    payload: { custValue },
  });
  return custValue;
}

function* onTriggerAxaGoal() {
  try {
    yield showAxaGoalDashboard();
  } catch (err) {
    console.error(err);
  }
}

function* axagoalHomeSaga(): Iterable<any> {
  let isShowHomeVhisIntro = false;
  do {
    try {
      const state = yield select();
      const pathName = state.router.location.pathname;
      if (pathName === '/home' && !isShowHomeVhisIntro) {
        if (yield shouldShowAxaGoalPopupOnce()) {
          // if not completed enrollment, open axa goal pop up
          yield axagoalWisModalShow();
          HomePagePopUpRegistry.setFetchDataCompleted(EMMA_AXA_GOAL, true);
          isShowHomeVhisIntro = true;
        } else {
          HomePagePopUpRegistry.setFetchDataCompleted(EMMA_AXA_GOAL);
        }
      } else {
        HomePagePopUpRegistry.setFetchDataCompleted(EMMA_AXA_GOAL);
      }
    } catch (e) {
      HomePagePopUpRegistry.setFetchDataCompleted(EMMA_AXA_GOAL);
      yield put({ type: AXAGOAL_LOAD_FAIL, error: e });
    }
    while (true) {
      const action = yield take(LOCATION_CHANGE);
      if (action.payload.location.pathname === '/home') {
        break;
      }
    }
  } while (true);
}
// sync with mobile: shouldShowAxaGoalPopupOnce
function* shouldShowAxaGoalPopupOnce() {
  const { features } = yield waitUntilReadStateIsReady();
  const disclaimerKey = yield select(getDisclaimerInfoApiKey);
  const isClosedDisclaimerBefore = !!features.find(
    (feature: { id: any; clickCount: any }) => {
      return feature.id === disclaimerKey && feature.clickCount;
    },
  );
  if (isClosedDisclaimerBefore) {
    return false;
  }
  const canJoinAxaGoal = yield getCanJoinAxaGoal();
  return canJoinAxaGoal;
}
function* waitUntilReadStateIsReady() {
  let haveReadNewFeature = yield select(getHaveReadNewFeatures);
  while (haveReadNewFeature === undefined) {
    yield delay(1000);
    haveReadNewFeature = yield select(getHaveReadNewFeatures);
  }
  return haveReadNewFeature;
}
// sync with mobile: getCanJoinAxaGoal
function* getCanJoinAxaGoal() {
  const axaGoalPolicies = yield getInsuredAxaGoalPolicies();
  if (!axaGoalPolicies || axaGoalPolicies.length === 0) return false; // must have axa goal policies

  const {
    policies = [],
    isJoinedAxaGoal = false,
    isAcceptedDisclaimer = false,
  } = yield fetchAxaGoalDisclaimerInfo();
  const hasEligiblePolicy = yield getPolicyForJoinAxaGoal();

  const canJoinAxaGoal =
    Array.isArray(policies) &&
    hasEligiblePolicy && // new disclaimer state should contain policies
    (!isJoinedAxaGoal || !isAcceptedDisclaimer); // otherwise, determine with legacy fields
  return canJoinAxaGoal;
}
// sync with mobile: getPoliciesForJoinAxaGoal
function* getPoliciesForJoinAxaGoal() {
  const axaGoalPoliciesFromApi = yield getInsuredAxaGoalPolicies();
  const axaGoalPoliciesFromDisclaimer =
    yield getAxaGoalPoliciesFromDisclaimer();

  const eligiblePolicies = _.filter(axaGoalPoliciesFromApi, (axaGoalPolicy) => {
    // not lapsed
    if (axaGoalPolicy.isLapsedPolicy === 'Y') {
      return false;
    }
    const p = axaGoalPoliciesFromDisclaimer.find(
      (p: { policyNumber: any }) =>
        axaGoalPolicy.policyNumber === p.policyNumber,
    );
    return (
      !_.get(p, 'isAcceptedAxaGoalTnc') ||
      !_.get(p, 'isAcceptedHealthKeeperTnc')
    );
  });
  return eligiblePolicies;
}
// sync with mobile: getPolicyForJoinAxaGoal
function* getPolicyForJoinAxaGoal() {
  const axaGoalPolicies = yield getPoliciesForJoinAxaGoal();
  const r = _.head(axaGoalPolicies);
  return r;
}
// sync with mobile: getInsuredAxaGoalPolicies
function* getInsuredAxaGoalPolicies() {
  const policies = yield select(getCustomerPolicies);
  const axaGoalPoliciesFromApi = _.filter(
    policies,
    (p) =>
      (p.isOwnIsuredFlag === 'Y' ||
        (p.partyRoleCd === 'INS' && p.isOwnIsuredFlag !== 'Y')) && // is only-insured / OWN-INS
      p.isWiseGuardProPolicyFlag === 'Y', // is AXA Goal policy (same with axaGoalEnrollFlag)
  );
  return axaGoalPoliciesFromApi;
}
// sync with mobile: getAxaGoalPoliciesFromDisclaimer
function* getAxaGoalPoliciesFromDisclaimer() {
  const disclaimerInfo = yield fetchAxaGoalDisclaimerInfo();
  const axaGoalPoliciesFromDisclaimer: Array<any> =
    disclaimerInfo.policies || [];
  return axaGoalPoliciesFromDisclaimer;
}

function* axagoalWisModalShow() {
  const show = { isShowVhisModal: true, isOutOfPopupQueue: true };
  yield put({ type: VHIS_MODAL_DISPLAY, show });
  yield put({ type: SHOW_MODAL });
}
function* showAxaGoalDashboard() {
  if (window.location.pathname.includes(EMMA_MY_PRIVILEGES_PATH_NAME)) {
    yield goto(AXA_GOAL_DASHBOARD_PRIVILEGES_DEEPLINK_ID);
    return;
  }
  yield goto(AXA_GOAL_DASHBOARD_HOME_DEEPLINK_ID);
  return;
}
function* showAxaGoalSeeAllPolicy() {
  if (window.location.pathname.includes(EMMA_MY_PRIVILEGES_PATH_NAME)) {
    yield goto(AXA_GOAL_SEE_ALL_POLICY_DEEPLINK_MYPRIVILEGES);
    return;
  }
  yield goto(AXA_GOAL_SEE_ALL_POLICY_DEEPLINK_HOME);
  return;
}
function* showAxaGoalSupport(action) {
  const entityCode = yield select(getAxaGoalSupportEntityCode) || '';
  if (window.location.pathname.includes(EMMA_MY_PRIVILEGES_PATH_NAME)) {
    if (action?.ruleType) {
      if (action?.ruleType === 'WGP') {
        yield goto(
          `${AXA_GOAL_SUPPORT_WGP_DEEPLINK_MYPRIVILEGES}?entityCode=${entityCode}`,
        );
        return;
      } else if (action?.ruleType === 'SH') {
        yield goto(
          `${AXA_GOAL_SUPPORT_SH_DEEPLINK_MYPRIVILEGES}?entityCode=${entityCode}`,
        );
        return;
      }
    }
    yield goto(
      `${AXA_GOAL_SUPPORT_DEEPLINK_MYPRIVILEGES}?entityCode=${entityCode}`,
    );
    return;
  }
  if (action?.ruleType) {
    if (action?.ruleType === 'WGP') {
      yield goto(
        `${AXA_GOAL_SUPPORT_WGP_DEEPLINK_HOME}?entityCode=${entityCode}`,
      );
      return;
    } else if (action?.ruleType === 'SH') {
      yield goto(
        `${AXA_GOAL_SUPPORT_SH_DEEPLINK_HOME}?entityCode=${entityCode}`,
      );
      return;
    }
  }
  yield goto(`${AXA_GOAL_SUPPORT_DEEPLINK_HOME}?entityCode=${entityCode}`);
  return;
}

function* axagoalInnerPageSaga(): Iterable<any> {
  do {
    try {
      const state = yield select();
      const pathName = state.router.location.pathname;
      if (
        pathName.indexOf('/home/life/axagoal/membership/') > -1 ||
        pathName.indexOf('/home/life/axagoal/summary') > -1 ||
        pathName.indexOf('/home/life/axagoal/recode') > -1
      ) {
        const state = yield select();
        let path;
        if (pathName.indexOf('/home/life/axagoal/membership/') > -1) {
          path = '/home/life/axagoal/membership/';
        } else {
          path = '/home/life/axagoal/summary/';
          if (pathName.indexOf('/home/life/axagoal/recode/') > -1) {
            const isFirstYear = getAxagoalIsFirstYear(state);
            const campaignDetail = getCampaignDetail(state, isFirstYear);
            if (campaignDetail.policyNumber) {
              return;
            }
            path = '/home/life/axagoal/recode/:month/:achieveDays/:entityCode/:ruleType';
          }
          if (pathName.indexOf('/home/life/axagoal/summary-WGP/') > -1) {
            path = '/home/life/axagoal/summary-WGP/';
          }
          if (pathName.indexOf('/home/life/axagoal/summary-SH/') > -1) {
            path = '/home/life/axagoal/summary-SH/';
          }
        }
        if (window.location.pathname.indexOf(`/${MOB_PREFIX}/`) > -1) {
          path = `/mob${path}`;
        }

        const isPathContainIdMatcher = path.includes(':');
        const finalPath = isPathContainIdMatcher
          ? path
          : path + ':id/:entityCode';

        const param = yield createMatchSelector(finalPath)(state);
        const id = getPolicyNumberFromStore();
        const entityCode = param.params.entityCode;
        const token = yield select(getToken);
        if (token) {
          const stepCountSummary = yield select(getStepCountSummaryApi);
          if (stepCountSummary) {
            // TODO start: [HKEMMA_26823]: delete test data
            // const membershipPeriodRes = { status: 200, json: () => require('../mock/stepCountDetails.json') };
            // TODO end: [HKEMMA_26823]: delete test data
            const membershipPeriodRes = yield call(
              myAxaFetchWithToken,
              stepCountSummary +
                `?entityCode=${entityCode}&policyNumber=${id}&enrollmentFlag=Y&featureName=stepsummary`,
              {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'x-axahk-msgid': uuidv4(),
                },
              },
            );
            const stepCountSummaryData = yield membershipPeriodRes.json();

            if (!stepCountSummaryData) throw new Error();
            yield put({ type: FETCH_STEP_COUNT_SUMMARY, stepCountSummaryData });
          }
        }
      }
    } catch (e) {
      yield put({ type: AXAGOAL_LOAD_FAIL, error: e });
    }
    while (true) {
      const action = yield take(LOCATION_CHANGE);
      if (
        action.payload.location.pathname.indexOf(
          '/home/life/axagoal/membership/',
        ) > -1 ||
        action.payload.location.pathname.indexOf('/home/life/axagoal/summary') >
          -1
      ) {
        break;
      }
    }
  } while (true);
}

const MY_AXA_FE_POLICY_DETAILS_POP_UP_HASH = '#intro';
function* axagoalModalSaga(action: any): Iterable<any> {
  if (action.payload.location.hash === MY_AXA_FE_POLICY_DETAILS_POP_UP_HASH) {
    yield axagoalWisModalShow();
    window.history.back();
  }
}

function* fetchCampaignStartedSaga(): Iterable<any> {
  try {
    const shouldShowAxaGoalPopup = yield shouldShowAxaGoalPopupOnce();
    yield put(toggleCampaignButton(shouldShowAxaGoalPopup));
  } catch (err) {
    yield put(toggleCampaignButton(false));
  }
}

function* onClosedAxaGoalDisclaimer() {
  const disclaimerKey = yield select(getDisclaimerInfoApiKey);
  yield put(pushHaveReadNewFeatureSingle(disclaimerKey, 1, 1));
}

function* setShowPopup(): Iterable<any> {
  while (true) {
    yield take(BANNER_TO_SHOW);
    const isShowPopup = HomePagePopUpRegistry.getIsDisplay(EMMA_AXA_GOAL);
    if (isShowPopup) {
      const show = { isShowPopupModal: true };
      yield put({ type: EMMA_AXA_GOAL_POPUP, show });
    }
  }
}

function* getAktivoStepStats(action: any) {
  const { startDate, endDate } = action.payload;
  const token = yield select(getToken);
  try {
    if (!isDateObjectValid(startDate) || !isDateObjectValid(endDate)) {
      throw 'date value error';
    }
    const aktivoApiClient = yield new AktivoAPIClient(token);
    const res = yield aktivoApiClient.stepsStats({
      startDate: moment(startDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
    });
    yield put({
      type: FETCH_AKTIVO_STEP_STATS_SUCCESS,
      payload: {
        aktivoStepStats: res.data.stepsStats.stats,
      },
    });
  } catch (err) {
    console.log(err);
  }
}

function* axagoalSaga() {
  yield fork(axagoalHomeSaga);
  yield takeLatest(LOCATION_CHANGE, axagoalModalSaga);
  yield takeLatest(SHOW_AXA_GOAL_DASHBOARD, onTriggerAxaGoal);
  yield takeLatest(CLOSED_AXA_GOAL_DISCLAIMER, onClosedAxaGoalDisclaimer);
  yield takeLatest(FETCH_CAMPAIGN_STARTED, fetchCampaignStartedSaga);
  yield takeLatest(SHOW_AXA_GOAL_SEE_ALL_POLICY, showAxaGoalSeeAllPolicy);
  yield takeLatest(SHOW_AXA_GOAL_SUPPORT, showAxaGoalSupport);
  yield takeLatest(FETCH_AKTIVO_STEP_STATS, getAktivoStepStats);
  // yield take(FRAME_APP_MOUNTED);
  yield fork(axagoalInnerPageSaga);
  yield fork(setShowPopup);
}

export default axagoalSaga;
